import { ContactAsSection } from "../components/ContactAsSection/ContactAsSection";
import HeroSection from "../components/HeroSection/HeroSection";
import OurServiceSection from "../components/OurServiceSection/OurService";
import TenYearsSection from "../components/TenYearsSection/TenYearsSection";
import WhyChooseUsSection from "../components/WhyChooseUsSection/WhyChooseUsSection";

const HomePage = () => {
  return (
    <>
      <HeroSection />
      <OurServiceSection />
      <TenYearsSection />
      <WhyChooseUsSection />
      <ContactAsSection />
    </>
  );
};

export default HomePage;
